import React from 'react';
import { DocumentTitle } from '@atlassian/jira-global-document-title/src/DocumentTitle.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import type { Sprint } from '../../model/sprint/sprint-types.tsx';
import messages from './messages.tsx';

type Props = {
	boardName: string;
	sprints?: Sprint[];
	isKanbanBoard?: boolean;
} & Intl;

const DocumentTitleOld = ({ intl, boardName, sprints }: Props) => {
	return (
		<DocumentTitle
			title={intl.formatMessage(messages.pageTitleWithSprintOld, {
				boardName,
				sprintCount: sprints?.length || 0,
				sprintName: sprints?.length ? sprints[0].name : '',
			})}
		/>
	);
};

const DocumentTitleNew = ({ intl, boardName, sprints, isKanbanBoard }: Props) => {
	return (
		<DocumentTitle
			title={intl.formatMessage(messages.pageTitleWithSprintNew, {
				boardName,
				sprintCount: sprints?.length || 0,
				sprintName: sprints?.length ? sprints[0].name : '',
				isKanbanBoard,
			})}
		/>
	);
};

export default componentWithFG(
	'jfp-a11y-team-boards-document-title',
	DocumentTitleNew,
	DocumentTitleOld,
);
